/*actiontypes*/
export const POST_DATA_TO_CART_LOADING = "POST_DATA_TO_CART_LOADING";

export const POST_DATA_TO_CARTS_SUCCESS = "POST_DATA_TO_CARTS_SUCCESS";

export const POST_DATA_TO_CART_ERROR = "POST_DATA_TO_CART_ERROR";